import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ConfigService} from "./config.service";
import {Observable} from "rxjs";
import {BookkeepingOrganisationOverview} from "../models/bookkeeping/bookkeeping-organisation-overview";

@Injectable()
export class BookkeepingService {
    constructor(private http: HttpClient, private configService: ConfigService) {
    }

    getOrganisationOverview(organisationReference: string): Observable<BookkeepingOrganisationOverview> {
        return this.http.get<BookkeepingOrganisationOverview>(`${ this.configService.baseUrl }/manage/organisation/${ organisationReference }/bookkeeping/overview`);
    }
}
